import { render, staticRenderFns } from "./edit-family-planning-data.vue?vue&type=template&id=3a66d528"
import script from "./edit-family-planning-data.vue?vue&type=script&lang=ts"
export * from "./edit-family-planning-data.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports